const successResponse = {
  response: {
    data: {
      result: true,
    },
  },
};

const errorResponse = {
  response: {
    status: 400,
    data: {
      email: [
        'Выбранное значение некорректно.',
      ],
      password: [
        'Выбранное значение некорректно.',
      ],
      captcha: [
        'Выбранное значение некорректно.',
      ],
    },
  },
};

const mockSignInRequest = (
  success = true,
  onSuccess = () => {},
  onFail = () => {},
) => (
  success ? onSuccess(successResponse) : onFail(errorResponse)
);

export default mockSignInRequest;
